import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import LoginP2P from './Auth/Login';
import VerifyOtp from './Auth/OTP/verifyOtp';
import TermsAndConditions from './TermsAndConditions';
import PrivacyPolicy from './PrivacyPolicy';
import './style.scss';
import './responsive.scss';
import RoutesWithheader from './RoutesWithheader';
import ScrollToTop from './scrollToTop';

const P2PRoutes = () => {
  return (
    <div className='p2p'>
      <Router>
        <ScrollToTop />
        <Switch>
          <Route exact path='/' component={LoginP2P} />
          <Route exact path='/p2p/verifyOtp' component={VerifyOtp} />
          <Route
            exact
            path='/p2p/termsAndConditions'
            component={TermsAndConditions}
          />
          <Route exact path='/p2p/privacyPolicy' component={PrivacyPolicy} />
          <RoutesWithheader />
        </Switch>
      </Router>
    </div>
  );
};

export default P2PRoutes;
